<template>
  <div class="modals-container">
    <MenuItemModal />
    <TermItemModal />
    <SelectelUploadModal />
  </div>
</template>

<script>

import MenuItemModal from '../global/components/modals/MenuItem';
import TermItemModal from '../global/components/modals/TermItem';
import SelectelUploadModal from '../global/components/modals/SelectelUpload';

export default {
  name: 'Modals',

  components: {
    MenuItemModal,
    TermItemModal,
    SelectelUploadModal,
  },
};
</script>



// WEBPACK FOOTER //
// Modals.vue?1e564268